import RetainScrollPostion from "./RetainScrollPosition";

export const retainScrollPosition = {
    init: () => {
        const activeElement = document.getElementById('active');
        new RetainScrollPostion(activeElement);
    },
};

export default retainScrollPosition;
